// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   RelationGraphPage.responsive.css
   Responsive Stylesheet for Patient Clinical Intelligence Graph
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgclinical-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgclinical-hero {
    grid-template-columns: 1fr !important;
    gap: 20px !important;
    padding: 24px !important;
  }

  .mgclinical-hero h1 {
    font-size: clamp(26px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgclinical-controls {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }

  .mgclinical-controls .mgclinical-btn {
    min-height: 40px !important;
  }

  .mgclinical-svg-wrap {
    height: 540px !important;
    min-height: 540px !important;
    border-radius: 16px !important;
  }

  .mgclinical-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }

  .mgclinical-breakdown {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgclinical-page {
    padding: 10px 10px 30px !important;
  }

  .mgclinical-hero {
    padding: 16px 14px !important;
    gap: 14px !important;
    border-radius: 16px !important;
  }

  .mgclinical-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgclinical-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 8px 0 12px !important;
  }

  .mgclinical-controls {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  .mgclinical-field {
    width: 100% !important;
  }

  .mgclinical-field select {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13.5px !important;
  }

  .mgclinical-btn {
    width: 100% !important;
    min-height: 40px !important;
    font-size: 13px !important;
  }

  /* SVG Graph view */
  .mgclinical-svg-wrap {
    height: 420px !important;
    min-height: 420px !important;
    border-radius: 14px !important;
    touch-action: none !important;
  }

  .mgclinical-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 6px !important;
    margin: 14px 0 !important;
  }

  .mgclinical-stat-card {
    padding: 10px 8px !important;
    border-radius: 12px !important;
  }

  .mgclinical-stat-card strong {
    font-size: 18px !important;
  }

  .mgclinical-stat-card span {
    font-size: 10px !important;
  }

  .mgclinical-breakdown {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }

  .mgclinical-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .mgclinical-panel-top,
  .mgclinical-card-head {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 6px !important;
  }

  .mgclinical-context-menu {
    width: calc(100vw - 24px) !important;
    left: 12px !important;
    right: 12px !important;
    border-radius: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RelationGraphPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,mBAAmB;EACnB;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;EAChC;AACF","sourcesContent":["/* ==========================================================================\n   RelationGraphPage.responsive.css\n   Responsive Stylesheet for Patient Clinical Intelligence Graph\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgclinical-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgclinical-hero {\n    grid-template-columns: 1fr !important;\n    gap: 20px !important;\n    padding: 24px !important;\n  }\n\n  .mgclinical-hero h1 {\n    font-size: clamp(26px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgclinical-controls {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin-top: 16px !important;\n  }\n\n  .mgclinical-controls .mgclinical-btn {\n    min-height: 40px !important;\n  }\n\n  .mgclinical-svg-wrap {\n    height: 540px !important;\n    min-height: 540px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgclinical-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n  }\n\n  .mgclinical-breakdown {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgclinical-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgclinical-hero {\n    padding: 16px 14px !important;\n    gap: 14px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgclinical-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgclinical-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 8px 0 12px !important;\n  }\n\n  .mgclinical-controls {\n    grid-template-columns: 1fr !important;\n    gap: 8px !important;\n  }\n\n  .mgclinical-field {\n    width: 100% !important;\n  }\n\n  .mgclinical-field select {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13.5px !important;\n  }\n\n  .mgclinical-btn {\n    width: 100% !important;\n    min-height: 40px !important;\n    font-size: 13px !important;\n  }\n\n  /* SVG Graph view */\n  .mgclinical-svg-wrap {\n    height: 420px !important;\n    min-height: 420px !important;\n    border-radius: 14px !important;\n    touch-action: none !important;\n  }\n\n  .mgclinical-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 6px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgclinical-stat-card {\n    padding: 10px 8px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgclinical-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgclinical-stat-card span {\n    font-size: 10px !important;\n  }\n\n  .mgclinical-breakdown {\n    grid-template-columns: 1fr !important;\n    gap: 10px !important;\n  }\n\n  .mgclinical-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .mgclinical-panel-top,\n  .mgclinical-card-head {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 6px !important;\n  }\n\n  .mgclinical-context-menu {\n    width: calc(100vw - 24px) !important;\n    left: 12px !important;\n    right: 12px !important;\n    border-radius: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
